// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"0":"openOnPhone","96":"vendors","636":"landing"}[chunkId] + "." + {"0":"c8a4ad45b32ebcbd4eaa","96":"c51e642beb53a3ffbd1f","636":"e0ed239323634ac4db56"}[chunkId] + ".bundle.js";
};